import React from 'react';
import { ReactComponent as LocationSvg } from '../../../../assets/icons/location.svg';
import { ReactComponent as LocationGreySvg } from '../../../../assets/icons/location-grey.svg';
import { Button, ConfigProvider, Flex, Typography } from 'antd';
import { HYPHEN } from '../../../../utilities/constants';
import PropTypes from 'prop-types';

const { Text } = Typography;
const ResolvedSOSCard = ({ data, onTripDetailClick }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSize: '0.875rem',
          },
        },
      }}
    >
      <Flex vertical gap={12}>
        <Text>
          <b>
            {data?.trip_id || HYPHEN} | {data?.device_id || HYPHEN}
          </b>
        </Text>
        <Text>Resolved By: {data?.resolvedBy}</Text>
        <Text>
          Resolved At: <Text type="success">{data?.resolvedAt || HYPHEN}</Text>
        </Text>
        <Flex justify="flex-end">
          <Button
            className="sos-card-action-button"
            icon={data?.trip_id ? <LocationSvg /> : <LocationGreySvg />}
            onClick={() =>
              onTripDetailClick(
                data,
                data?.trip_id,
                data?.device_id,
                data?.anomaly_id
              )
            }
            disabled={!data?.trip_id}
          />
        </Flex>
      </Flex>
    </ConfigProvider>
  );
};

ResolvedSOSCard.propTypes = {
  data: PropTypes.object,
  onTripDetailClick: PropTypes.func.isRequired,
};

export default React.memo(ResolvedSOSCard);
